import * as Integrations from '@sentry/integrations'
import * as Sentry from '@sentry/browser'
import _ from 'lodash'
import Vue from 'vue'

export const productionEnv = 'production'
export const appReleaseEnvs = ['prod', 'demo', 'qa']

export function initSentry(env) {
  const environment = env || window.$appConfig.VUE_APP_ENVIRONMENT_SLUG

  if (window.$appConfig.NODE_ENV !== productionEnv) {
    return
  }

  const sentryConfig = {
    dsn: window.$appConfig.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.Vue({ Vue, attachProps: false })],
    environment: environment
  }

  if (_.includes(appReleaseEnvs, window.$appConfig.VUE_APP_ENVIRONMENT_SLUG)) {
    sentryConfig.release = `viper-ui@${process.env.VERSION}`
  }

  Sentry.init(sentryConfig)
}

export function configureSentryContext(user, organization, roles) {
  Sentry.configureScope(scope => {
    scope.setUser({
      id: user.id,
      username: user.username,
      email: user.email
    })

    scope.setTag('organization', _.get(organization, 'name', 'NOT_SET'))
    scope.setTag('roles', _.join(roles))
  })
}
